module.exports = __webpack_public_path__ + "static/media/Discussion-rafiki.d18dd62f.svg";